import { render, staticRenderFns } from "./TobaccoWarning.vue?vue&type=template&id=08dfa384"
import script from "./TobaccoWarning.vue?vue&type=script&lang=js"
export * from "./TobaccoWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports